import React from 'react';
import { REASON_CODE_LABELS } from '../constants';
import { NO_MATCH_REASONS_YET, WHY_THIS_MATCHED_LABEL } from '../commissionerReviewCopy';

interface ReasonCodePillsProps {
  codes?: string[];
  emptyLabel?: string;
}

const ReasonCodePills: React.FC<ReasonCodePillsProps> = ({
  codes = [],
  emptyLabel = NO_MATCH_REASONS_YET,
}) => {
  if (!codes.length) {
    return (
      <span className="text-secondary-500 text-sm" data-testid="reason-codes-empty">
        {emptyLabel}
      </span>
    );
  }

  return (
    <div className="flex flex-wrap gap-2" data-testid="reason-codes-list" aria-label={WHY_THIS_MATCHED_LABEL}>
      {codes.map((code) => (
        <span
          key={code}
          className="rounded-full bg-primary-900/40 border border-primary-700 px-2 py-0.5 text-xs text-primary-200"
          title={code}
        >
          {REASON_CODE_LABELS[code] ?? code.replace(/_/g, ' ').toLowerCase()}
        </span>
      ))}
    </div>
  );
};

export default ReasonCodePills;
